import { useCallback, useEffect, useState } from 'react';
export function storedValue(org) {
    var _a;
    const value = (_a = org === null || org === void 0 ? void 0 : org.options) === null || _a === void 0 ? void 0 : _a.dupe_tickets;
    return value === 'soft_stop' || value === 'hard_stop' ? value : '';
}
export function useDuplicateTicketBehaviorField(org) {
    const [value, setValue] = useState(() => storedValue(org));
    const reset = useCallback(() => {
        setValue(storedValue(org));
    }, [org]);
    useEffect(() => {
        const nextValue = storedValue(org);
        if (value !== nextValue) {
            setValue(nextValue);
        }
    }, [org]);
    const toOptionsPatch = useCallback(() => {
        return { dupe_tickets: value || null };
    }, [value]);
    return { value, setValue, reset, toOptionsPatch };
}
